import React, { FunctionComponent } from 'react';
import { ChannelNetworkList } from './ChannelNetworkList';
import { usePageLoaded } from 'hooks/usePageLoaded';
import { LogoImage } from 'components/LogoImage';
import { ThumbImage } from 'components/Images/ThumbImage';
import { useAppSelector } from 'hooks/redux';
import { useSEOTitleDescription } from 'hooks/useSEOTitleDescription';
import { SEOHeaderTags } from 'components/SEO/SEOHeaderTags';

export const ChannelNetworkView: FunctionComponent = () => {
  const channel = useAppSelector((state) => state.channel.channelDetails);

  usePageLoaded();

  const { pageTitle, pageDescription } = useSEOTitleDescription(
    `${channel?.username} network`,
    `Explore the channel network for ${channel?.username}`,
    true
  );

  if (!channel) {
    return null;
  }

  return (
    <>
      <SEOHeaderTags
        title={pageTitle}
        description={pageDescription}
        url={window.location.href}
      />
      <section className="tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center tw-p-8 tw-h-full tw-w-full">
        <header className="tw-mb-8 dm:tw-mb-12 tw-text-center tw-max-w-prose">
          <LogoImage size={'medium'}>
            <ThumbImage
              artworkUrl={channel?.channelLogo.image.small}
              artworkMode={'logo'}
              alt={`Logo for ${channel?.username}`}
            />
          </LogoImage>
          <h1 className="tw-m-0">{channel?.username} network</h1>
        </header>
        <div className="tw-max-w-[800px] tw-w-full">
          <ChannelNetworkList renderAsGrid={true} />
        </div>
      </section>
    </>
  );
};
